import { useState } from 'react';

import { getListPayload } from 'coreOld/utils';
import { useGetPricingList } from 'partsOld/hooks';
import { ICompanyPart } from 'partsOld/types';

import { columns } from './columns';
import PricingListView from './PricingListView';

interface IProps {
  part: Partial<ICompanyPart>;
  onRowClick: (row) => void;
}

const getPayload = (part: Partial<ICompanyPart>) => {
  return getListPayload({ corporatePartId: part?.id });
};

const PricingList = ({ part, onRowClick }: IProps) => {
  const [requestPayload] = useState(getPayload(part));

  const { records, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } =
    useGetPricingList(requestPayload);

  return (
    <PricingListView
      tableColumns={columns(part)}
      pricingList={records}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      onRowClick={onRowClick}
    />
  );
};

export default PricingList;
